import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-svg-images',
  templateUrl: './svg-images.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgImagesComponent {
  @Input() svgName: string = '';
}
